/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const LocationPinFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Location pin filled"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      fillRule="evenodd"
      d="M12 22s8.5-4.156 8.5-11.688C20.5 5.722 16.694 2 12 2s-8.5 3.722-8.5 8.312C3.5 17.844 12 22 12 22m0-8.571c1.565 0 2.833-1.28 2.833-2.858S13.565 7.714 12 7.714s-2.833 1.28-2.833 2.857S10.435 13.43 12 13.43"
      className="SVG"
      clipRule="evenodd"
    />
  </svg>
);

export const LocationPinFilledIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'location-pin-filled-icon'}
      icon={LocationPinFilled}
      {...props}
      size={size}
    />
  );
};
